import React, { useMemo } from "react";

interface ContainerProps {
  containerClassName?: string;
  className?: string;
  id?: string;
}

const Container: React.FC<ContainerProps> = ({
  containerClassName = "",
  children,
  className,
  id = "",
}) => {
  const classNames: string = useMemo(() => {
    const classes = ["max-w-screen-xl w-full mx-auto"];
    if (className) {
      classes.push(className);
    }
    return classes.join(" ");
  }, [className]);
  return (
    <section className={containerClassName} id={id}>
      <section className={classNames}>{children}</section>
    </section>
  );
};

export default Container;
